import React, { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { Authcontext } from '../components/context/Authcontext'

const Protectroute=(props)=> {
    const currentuser = useContext(Authcontext);
    if(currentuser){
        return props.children
    }else{
        return <Navigate to={'/'}/>
    }
}
export default Protectroute